<template>
  <div
    class="sticky-header"
  >
    <div class="sticky-header-items" :class="documentClass">
      <template
        v-for="({
          id, label, class: divClass, downArrowDirection, sortable, tooltip,
        }) in headerColumns"
        :key="id"
      >
        <div
          v-if="id === '__select'"
          class="select-all-header h-100 d-flex align-center"
          :class="{ [divClass]: true }"
          @click.stop
        >
          <DpplSimpleCheckbox
            :model-value="selectAll"
            :option="{ id: 'select-all', label: '' }"
            hide-label
            size="md"
            border-radius="6px"
            :disabled="selectAllDisabled"
            @update:model-value="$emit('update:selectAll', $event)"
          />
        </div>
        <StickyListHeaderItem
          v-else
          :div-class="divClass"
          :label="label"
          :tooltip="tooltip"
          :selected-sort="selectedSort"
          :selected-sort-direction="sortDirection"
          :down-arrow-sort-direction="downArrowDirection"
          :sort-id="id"
          :sortable="sortable"
          @submit-sort="$emit('submitSort', id)"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';
import StickyListHeaderItem from './StickyListHeaderItem.vue';

defineProps({
  documentClass: {
    type: String,
    default: 'item-draft', // make required
  },
  headerColumns: {
    type: Array,
    default() {
      return [];
    },
  },
  leftSideColumns: {
    type: Array,
    default() {
      return [];
    },
  },
  rightSideColumns: {
    type: Array,
    default() {
      return [];
    },
  },
  selectedSort: {
    type: String,
    required: true,
  },
  sortDirection: {
    type: String,
    required: true,
  },
  selectAll: {
    type: Boolean,
    default: false,
  },
  selectAllDisabled: {
    type: Boolean,
    default: false,
  },
  topOffset: {
    type: String,
    default: '140px',
  },
});

defineEmits(['submitSort', 'update:selectAll']);
</script>

<style lang="less" scoped>
.sticky-header {
  width: 100%;
  height: 40px;
  position: sticky;
  top: v-bind(topOffset);
  z-index: 2;
  background-color: @bg-canvas;
  border: 1px solid @stroke-default;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.sticky-header-items {
  display: grid;
  align-items: center;
  justify-items: start;
  gap: 16px;
}

.select-all-header {
  padding-left: 8px;
}
</style>
